// Rate of return options
export const LEGACY_ONLY_DATA = 'legacy';
export const DEFAULT_ONLY_DATA = 'default';
export const BOTH_DEFAULT_AND_LEGACY_DATA = 'both';
